import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { settleConfigModel } from '../settleConfigModel'
import YhTootip from '@/components/YhTootip'

export function DataTable() {

    const {
        dataSource, pgCfg,
        loadData,
        selectedRowKeys, setSelectedRowKeys,
    } = settleConfigModel()

    useEffect(() => {
        loadData()
    }, [])

    const columns = [
        {
            title: '加盟商名称',
            width: 160,
            dataIndex: 'franchiseeName',
            render: (text) => <YhTootip text={text} style={{ width: 160 }} />,
        },
        {
            title: '结算方式',
            width: 150,
            dataIndex: 'paymentMethod',
            render: (text) => {
                const str = text === "settlement_cyle_payment_method_regular" ? "每月固定日期结算" : text === "settlement_cyle_payment_method_cyle" ? "周期结算" : "";
                return <YhTootip text={str} style={{ width: 150 }} />
            }
        },
        {
            title: '结算类型',
            width: 150,
            dataIndex: 'settlementType',
            render: (text) => {
                const str = text === "settlement_cyle_type_order" ? "按单结算" : text === "settlement_cyle_type_amount" ? "按金额结算" : "";
                return <YhTootip text={str} style={{ width: 150 }} />
            }
        },
        {
            title: '结算日期',
            width: 150,
            dataIndex: 'accommodate',
            render: (t, r) => {
                const str = r.paymentMethod === "settlement_cyle_payment_method_regular" ? r.fixedTime + " 日" : r.settlementCycleData + " 天";
                return <YhTootip text={str} style={{ width: 150 }} />
            }
        },
        // {
        //     title: '进口工时比例',
        //     width: 150,
        //     dataIndex: 'workMarkupRate',
        //     render: (t, r) => {
        //         const str = r.repairAttribute === "进口" ? t : "";
        //         return <YhTootip text={str} style={{ width: 150 }} />
        //     }
        // },
        // {
        //     title: '国产工时比例',
        //     width: 150,
        //     dataIndex: 'workMarkupRate',
        //     render: (t, r) => {
        //         const str = r.repairAttribute === "国产" ? t : "";
        //         return <YhTootip text={str} style={{ width: 150 }} />
        //     }
        // },
        // {
        //     title: '配件比例',
        //     width: 150,
        //     dataIndex: 'accessoryMarkupRate',
        //     render: (text) => <YhTootip text={text} style={{ width: 150 }} />,
        // },
    ]


    return (
        <>
            <Table
                rowKey={(record) => record.id}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys,
                    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => setSelectedRowKeys([record.id]),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record.id])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 470px)' }}
            />
        </>
    )
}
